import React from 'react';
import { Container, Spinner, Row, Button, Col, Form } from 'react-bootstrap';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import Modal from 'react-bootstrap/Modal';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import GCDetails from '../GCAccounts/GCDetails'
import Checkbox from '@material-ui/core/Checkbox';

const pageSizes = [5, 10, 25, 50, 100];
const statusArray =[
    { key: 'All', value: '' },
    { key: 'Active', value: 'active' },
    { key: 'Disabled', value: 'disabled' },
]
const searchBy = [
    { key: 'Name', value: 'name' },
    { key: 'SKU', value: 'sku' },
    { key: 'Status', value: 'status' },
];

class AllGiftCards extends React.Component {
    _isMounted = false;
    state = {
        perPage: 5,
        pageNumber: 0,
        LastDocument: false,
        FirstDocument: false,
        StartAt: [],
        moveTo: false,
        search_key: '',
        search_by: 'name',
        ShowGCDetails: false,
        modalShow: false,
        GCmodalShow:false,
        alert: 0,
        alertMessage: '',
        data: [],
        selectedItem: [],
        flag: true,
        showAdd: false,
        showEdit: false,
        title:'',
        offer:0,
        dtic:0,
        DBCP:0,
        IBMP:0,
        IGMP:0,
        TotalProfileCount:0,
        Slug:this.props.Slug?this.props.Slug.slug:'',
        gc_key:'',
        gc_search_by:'name',
        gc_list:[],
        selected_gc:'',
        masterGCList:[],
        master_gc:this.props.Slug?this.props.Slug.master_gc:'',
        slug_name:this.props.Slug?this.props.Slug.name:'',
        weight:this.props.Slug?this.props.Slug.weight:0,
    };
    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
        this.loadData();
        this.loadMasterGiftCards()
    }
    

    
    async loadMasterGiftCards() {
        let bodyData = {
            search_key: '',
            search_by: '',
            userRole: 'Admins',
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo
        };

        await RestServices.getAllMasterGiftCards(
            localStorage.getItem('FirebaseToken'),
            bodyData
        )
            .then((response) => response.json())
            .then((responseData) => {
                    if (this._isMounted) {
                        this.setState({
                            masterGCList: responseData.list
                        });
                    }
            })
    }

    
    async loadData() {
        if (this._isMounted) {
            this.setState({showLoading: true });
        }
        let bodyData = {
            search_key: this.state.search_key,
            search_by: this.state.search_by,
            LastDocument: this.state.LastDocument,
            FirstDocument: this.state.FirstDocument,
            StartAt: await this.getStartAt(),
            perPage: parseInt(this.state.perPage),
            moveTo: this.state.moveTo,
            slug:this.state.Slug
        };
        
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'slugs/gc-by-slug'
         )
            .then((response) => response.json())
            .then((responseData) => {
                
                if(responseData.error){
                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            showLoading: false,
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                }else{
                
                    if (this.state.moveTo === 'Prev') {
                        var newPageNumber = this.state.pageNumber - 1;
                        var filteredArray = this.state.StartAt.filter(
                            (item) => item !== responseData.FirstDocument
                        );
                        if (filteredArray.length < 2) {
                            var filteredArray = [];
                            filteredArray.push(responseData.FirstDocument);
                        }
                    } else if (this.state.moveTo === 'Next') {
                        var newPageNumber = this.state.pageNumber + 1;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    } else {
                        var newPageNumber = 0;
                        var filteredArray = this.state.StartAt;
                        filteredArray.push(responseData.FirstDocument);
                    }

                    if (this._isMounted) {
                        this.setState({
                            flag: false,
                            showLoading: false,
                            alert: 0,
                            alertMessage: '',
                            data:responseData.data,
                            pageNumber: newPageNumber,
                            StartAt: filteredArray,
                            LastDocument: responseData.LastDocument,
                            FirstDocument: responseData.FirstDocument,
                        });
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({
                        showLoading: false,
                        alert: 1,
                        alertMessage: err.message
                    });
                }
            });
    }

    getStartAt = () => {
        let StartAtLIst = this.state.StartAt;

        if (StartAtLIst.length > this.state.pageNumber + 1) {
            StartAtLIst.splice(StartAtLIst.length - 2, StartAtLIst.length - 1);
            if (this._isMounted) {
                this.setState({ StartAt: StartAtLIst });
            }
        }
        return StartAtLIst[this.state.pageNumber - 1];
    };

    handlePageSizeChange = (event) => {
        if (this._isMounted) {
            this.setState({
                perPage: event.target.value,
                moveTo: false,
                StartAt: [],
                pageNumber: 0
            });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    submitSearch = () => {
        this.setState({ moveTo: false, StartAt: [], pageNumber: 0 });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };

    restSearch = () => {
        this.setState({
            search_key: '',
            moveTo: false,
            StartAt: [],
            pageNumber: 0
        });
        setTimeout(() => {
            this.loadData();
        }, 500);
    };
    paginateNext = () => {
        
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Next' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };

    paginatePrev = () => {
        if (this._isMounted) {
            this.setState({ flag: true, moveTo: 'Prev' });
            setTimeout(() => {
                this.loadData();
            }, 500);
        }
    };
    
    onChangeGCValues= (event) => {
            this.setState({gc_key:event.target.value})
    }
    onChangeGCBy= (event) => {
        this.setState({gc_search_by:event.target.value})
    }
    submitGCSearch= async () => {
        
        let bodyData = {
            MasterGiftCard:this.state.master_gc,
            search_key: this.state.gc_key,
            search_by: this.state.gc_search_by
        };
        
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'giftcards/all'
        )
            .then((response) => response.json())
            .then((responseData) => {
                if(responseData.data){
                this.setState({
                    gc_list: responseData.data
                });
                }
            })
    }

    onSelectGc = (event) => {
        this.setState({selected_gc:event.target.value})
    };

    UpdateGCConfirmed= async()=>{
        let bodyData={
            documentId:this.state.selected_gc,
            slug:this.state.Slug,
            slug_name:this.state.slug_name,
            weight:this.state.weight,
            master_gc:this.state.master_gc
        }
        
        await RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'slugs/update-gc-slug'
        )
            .then((response) => response.json())
            .then((responseData) => {
                    this.loadData()
                    this.handleClose()
            })
    }

    restGCSearch= () => {
        this.setState({gc_key:''})
    }

    onChangeValues = (event) => {
        if (event.target.value === ''){
            this.setState({ [event.target.name]: '' });
        }else {
            this.setState({ [event.target.name]: event.target.value });
        }
        if(event.target.name ==='offer'){
                this.updatedIGMP(event.target.value,this.state.DBCP)
        }
        if(event.target.name ==='dtic'){
            this.updatedICIGMP(event.target.value,this.state.DBCP)
        }
        if(event.target.name ==='DBCP'){
            this.updatedIGMP(this.state.offer,event.target.value)
        }

    };

    updatedICIGMP(OfferValue,DBCPValue){
        let DBCP = DBCPValue > 0 ? DBCPValue :0
        let offer = OfferValue > 0 ? OfferValue :0
        var IBMP = (parseFloat(DBCP)-parseFloat(offer)).toFixed(2)
        this.setState({ ['IGMP']: IBMP });
    }
    updatedIGMP(OfferValue,DBCPValue){
        let DBCP = DBCPValue > 0 ? DBCPValue :0
        let offer = OfferValue > 0 ? OfferValue :0
        var IBMP = (parseFloat(DBCP)-parseFloat(offer)).toFixed(2)
        this.setState({ ['IBMP']: IBMP });
    }

    

    editDetail = (item)=>{
        if (this._isMounted) {
        this.setState({selectedItem:item,title:item.name,dtic:item.dtic,offer:item.offer,DBCP:item.DBCP,IGMP:item.IGMP,IBMP:item.IBMP, modalShow: true,ShowGCDetails: false });
        }
    } 
    handleClose = () => {
        if (this._isMounted) {
            this.setState({selectedItem:[],title:'',dtic:'',offer:'',DBCP:'',IGMP:'',IBMP:'',GCmodalShow:false, modalShow: false,ShowGCDetails: false });
        }
    };
    
     

    

    UpdateConfirmed = () => {
        let bodyData = this.state.selectedItem;
        bodyData['name']=this.state.selectedItem.title;
        bodyData['DBCP']=this.state.DBCP;
        bodyData['offer']=this.state.offer;
        bodyData['IBMP']=this.state.IBMP;
        bodyData['dtic']=this.state.dtic;
        bodyData['IGMP']=this.state.IGMP;
        RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'giftcards/updateGCProfile?productSKU='+this.state.selectedItem.sku
        )
            .then((response) => response.json())
            .then((responseData) => {
                this.setState({ modalShow: false });
                
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    if (this._isMounted) {
                        this.loadData();
                        this.setState({selectedItem:[]});
                    }
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({ alert: 1, alertMessage: err.message });
                }
            });

    }
    updateGCStatus= () => {
        this.setState({showLoading: true });
        let bodyData = this.state.selectedItem;
        bodyData['status']=this.state.selectedItem.status=='disabled'?'active':'disabled'
        RestServices.GlobalPost(
            localStorage.getItem('FirebaseToken'),
            bodyData,
            'giftcards/updateGCProfile?productSKU='+this.state.selectedItem.sku
        )
            .then((response) => response.json())
            .then((responseData) => {
                
                this.setState({showLoading: false, selectedItem:[], confirmStatusUpdate: false });
                
                if (responseData.error) {
                    if (this._isMounted) {
                        this.setState({
                            alert: 1,
                            alertMessage: responseData.error
                        });
                    }
                } else {
                    this.state.selectedItem.status = this.state.selectedItem.status=='disabled'?'active':'disabled'
                }
            })
            .catch((err) => {
                if (this._isMounted) {
                    this.setState({alert: 1,
                        alertMessage: 'Oops some thing went wrong....',selectedItem:[],confirmStatusUpdate: false });
                }
            });


        
        
    }

    
    handleCloseConfirm= () => {
        if (this._isMounted) {
            this.setState({selectedItem:[],confirmStatusUpdate: false,ShowGCDetails: false });
        }
    }
    
    handleCheckboxChange = (item) => {
        this.setState({selectedItem:item, confirmStatusUpdate:true ,ShowGCDetails: false});
        
    };


    toggleGCDetails = (item)=>{
        if (this._isMounted) {
        this.setState({selectedItem:item,ShowGCDetails: true,modalShow: false ,confirmStatusUpdate:false });
        }
    } 
    hideGCDetails = ()=>{
        if (this._isMounted) {
            this.loadData();    
        this.setState({ShowGCDetails: false,modalShow: false ,confirmStatusUpdate:false });
        }
    }
    
    render() {
        const options = {
            actionsColumnIndex: -1
        };

        const actions = [
            {
                icon: 'edit',
                tooltip: 'Update',
                position: 'toolbar',
                onClick: () => {
                    if (this._isMounted) {
                        this.setState({GCmodalShow: true, selectedItem: [] });
                    }
                }
            }
        ];

        
        return (
            <Container className="no_padding">
                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.flag && <Spinner animation="border" />}
                {this.state.showLoading && <Spinner animation="border" />}

                
                            {this.state.ShowGCDetails?<div>
                            <Row>
                            <div>
                                <hr />
                            </div> 
                            </Row>
                            <Row>  
                            <KeyboardBackspaceRoundedIcon
                                style={{ cursor: 'pointer', color: 'blue' }}
                                onClick={(e) =>this.hideGCDetails()}
                            />
                            <h4
                                style={{
                                    marginLeft: '1rem',
                                    marginRight: '1rem'
                                }}
                                
                            >
                            {this.state.selectedItem.brandName ?<span>{this.state.selectedItem.brandName}</span>:<span>{this.state.selectedItem.name}</span>} 
                            </h4>
                            
                        </Row>

                        
                            <Row style={{ justifyContent: 'right' }}>
                                 <GCDetails gcard={this.state.selectedItem} {...this.props}/>
                            </Row>
                            </div>:<div>

                            <div>
                                <hr />
                            </div>
                            <Row>
                                <Col>
                                    <p><b>DBCP:</b>Discount by Company Percentage</p>
                                </Col>
                                <Col>
                                    <p><b>DTSP:</b>Discount to Store Percentage</p>
                                </Col>
                                <Col>
                                    <p><b>DTIC:</b>Discount to InstaGyfts Customers</p>
                                </Col>
                                <Col>
                                    <p><b>IBMP:</b>Indiabuys Margin Percentage</p>
                                </Col>
                                <Col>
                                    <p><b>IGMP:</b>InstaGyfts Margin Percentage</p>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <hr />
                                </Col>
                            </Row>
                            
                            <Row style={{ justifyContent: 'right' }}>
                                <Col
                                    style={{
                                        justifyContent: 'right',
                                        textAlign: 'right'
                                    }}
                                >
                                    <Form.Group
                                        as={Row}
                                        style={{
                                            justifyContent: 'right',
                                            marginRight: '0'
                                        }}
                                    >
                                        <select
                                            className="form-control"
                                            style={{ width: 'auto' }}
                                            name="search_by"
                                            onChange={this.onChangeValues}
                                            value={this.state.search_by}
                                        >
                                            {searchBy.map((search) => (
                                                <option
                                                    key={search.value}
                                                    value={search.value}
                                                >
                                                    Search By {search.key}
                                                </option>
                                            ))}
                                        </select>
                                        {this.state.search_by =='status' &&<select
                                        className="form-control"
                                        style={{ width: '200px',marginLeft: '1rem',marginRight: '1rem' }}
                                        name="search_key"
                                        onChange={this.onChangeValues}
                                        value={this.state.search_key}
                                    >
                                        {statusArray.map((search) => (
                                            <option
                                                key={search.value}
                                                value={search.value}
                                            >
                                                {search.key}
                                            </option>
                                        ))}
                                    </select>}
                                    {this.state.search_by !=='status' &&<Form.Control
                                        style={{
                                            marginLeft: '1rem',
                                            marginRight: '1rem',
                                            width: 'auto'
                                        }}
                                        placeholder="Search key"
                                        type="text"
                                        name="search_key"
                                        value={this.state.search_key}
                                        onChange={this.onChangeValues}
                                    />}
                                        <Button
                                            variant="primary"
                                            onClick={this.submitSearch}
                                        >
                                            Search
                                        </Button>

                                        <Button
                                            style={{ marginLeft: '1rem' }}
                                            variant="primary"
                                            onClick={this.restSearch}
                                        >
                                            Reset
                                        </Button>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <MaterialTable
                                components={{
                                    Pagination: PatchedPagination
                                }}
                                title={"Gift Cards"}
                                columns={[
                                    {
                                        title: 'Master GC',
                                        field: 'MasterGiftCard'
                                    },
                                    {
                                        title: 'Name',
                                        field: 'name',
                                        render: (row) => (
                                            <div style={{ cursor: 'pointer', color: 'blue' }} onClick={(e) =>this.toggleGCDetails(row)
                                            }>
                                                {row.name ?<span>{row.name}</span>:<span>{row.brandName}</span>}
                                            </div>
                                        )
                                        
                                    },
                                    {
                                        title: 'SKU',
                                        field: 'sku',
                                        
                                    },
                                    {
                                        title: 'DTSP',
                                        field: 'offer',
                                        render: (row) => (
                                            <div style={{ cursor: 'pointer', color: 'blue' }} onClick={(e) =>
                                                this.editDetail(row)
                                            }>
                                                {row.offer ?<span>{row.offer}%</span>:<span>0%</span>}
                                            </div>
                                        )
                                        
                                    },
                                    {
                                        title: 'DTIC',
                                        field: 'dtic',
                                        render: (row) => (
                                            <div style={{ cursor: 'pointer', color: 'blue' }} onClick={(e) =>
                                                this.editDetail(row)
                                            }>
                                                {row.dtic ?<span>{row.dtic}%</span>:<span>0%</span>}
                                            </div>
                                        )
                                        
                                    },
                                    {
                                        title: 'DBCP',
                                        field: 'DBCP',
                                        render: (row) => (
                                            <div style={{ cursor: 'pointer', color: 'blue' }} onClick={(e) =>
                                                this.editDetail(row)
                                            }>
                                                {row.DBCP ?<span>{row.DBCP}%</span>:<span>0%</span>}
                                            </div>
                                        )
                                        
                                    },
                                    {
                                        title: 'IBMP',
                                        field: 'IBMP',
                                        render: (row) => (
                                            <div>
                                                {row.IBMP ?<span>{row.IBMP}%</span>:<span>0%</span>}
                                            </div>
                                        )
                                        
                                    },
                                    {
                                        title: 'IGMP',
                                        field: 'IGMP',
                                        render: (row) => (
                                            <div>
                                                {row.IGMP ?<span>{row.IGMP}%</span>:<span>0%</span>}
                                            </div>
                                        )
                                        
                                    },
                                    {
                                        title: 'Status',
                                        field: 'status',
                                        render: (row) => (
                                            <div>
                                        <Checkbox
                                            label={row.sku}
                                            key={row.sku}
                                            name={row.sku}
                                            checked={row.status !== 'disabled'}
                                            onChange={(e) =>
                                                this.handleCheckboxChange(row)
                                            }
                                        />
                                    </div>
                                        )
                                        
                                    },
                                    
                                ]}
                                data={this.state.data}
                                actions={actions}
                                options={{
                                    filtering: false,
                                    search: false,
                                    sorting: false,
                                    paging: false,
                                    actionsColumnIndex: -1
                                }}
                            />

                            <div>
                                <hr />
                            </div>
                            <Row className="custom_pagination">
                                {this.state.StartAt.length > 1 && (
                                    <Col>
                                        <Button
                                            onClick={this.paginatePrev}
                                            variant="primary"
                                        >
                                            Prev
                                        </Button>
                                    </Col>
                                )}
                                {this.state.StartAt.length < 2 && (
                                    <Col>
                                        <Button
                                            variant="secondary"
                                            disabled={true}
                                        >
                                            Prev
                                        </Button>
                                    </Col>
                                )}

                                <Col style={{ textAlign: 'center' }}>
                                    {'Items per page:'}
                                    <select
                                        className="items_per_page"
                                        onChange={this.handlePageSizeChange}
                                        value={this.state.perPage}
                                    >
                                        {pageSizes.map((size) => (
                                            <option key={size} value={size}>
                                                {size}
                                            </option>
                                        ))}
                                    </select>
                                    Page: {this.state.StartAt.length}
                                </Col>

                                <Col style={{ textAlign: 'right' }}>
                                    {this.state.data.length <
                                        this.state.perPage && (
                                        <Button
                                            variant="secondary"
                                            disabled={true}
                                        >
                                            Next
                                        </Button>
                                    )}

                                    {this.state.data.length >=
                                        this.state.perPage && (
                                        <Button
                                            onClick={this.paginateNext}
                                            variant="primary"
                                        >
                                            Next
                                        </Button>
                                    )}
                                </Col>
                            </Row>
                        
                           </div>}
                <Modal  
                    show={this.state.modalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                    {this.state.selectedItem.brandName ?<Modal.Title>{this.state.selectedItem.brandName}</Modal.Title>:<Modal.Title>{this.state.selectedItem.name}</Modal.Title>}
                    </Modal.Header>

                    <Modal.Body>
                    
                    <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>DBCP (%)</Form.Label>
                                <Form.Control
                                    placeholder="Enter amount"
                                    type="number"
                                    name="DBCP"
                                    value={this.state.DBCP}
                                    onChange={this.onChangeValues}
                                />
                            </Form.Group>
                    </Form.Row>

                    <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>DTSP (%)</Form.Label>
                                <Form.Control
                                    placeholder="Enter amount"
                                    type="number"
                                    name="offer"
                                    value={this.state.offer}
                                    onChange={this.onChangeValues}
                                />
                            </Form.Group>
                    </Form.Row>

                    <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>DTIC (%)</Form.Label>
                                <Form.Control
                                    placeholder="Enter amount"
                                    type="number"
                                    name="dtic"
                                    value={this.state.dtic}
                                    onChange={this.onChangeValues}
                                />
                            </Form.Group>
                    </Form.Row>

                    <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>IBMP (%)</Form.Label>
                                <Form.Control
                                    disabled='disabled'
                                    type="number"
                                    name="IBMP"
                                    value={this.state.IBMP}
                                />
                            </Form.Group>
                    </Form.Row>

                    <Form.Row>
                            <Form.Group as={Col}>
                                <Form.Label>IGMP (%)</Form.Label>
                                <Form.Control
                                    disabled='disabled'
                                    type="number"
                                    name="IGMP"
                                    value={this.state.IGMP}
                                />
                            </Form.Group>
                    </Form.Row>

    
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.UpdateConfirmed}>
                        Update
                        </Button>
                        
                    </Modal.Footer>
                </Modal>
                

                <Modal
                    show={this.state.confirmStatusUpdate}
                    onHide={this.handleCloseConfirm}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>Please confirm</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <p>Are you sure you want to {this.state.selectedItem.status=='disabled'?'Activate':'Disabled'} this GC?</p>

                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleCloseConfirm}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={this.updateGCStatus} >
                            Yes
                        </Button>
                        
                    </Modal.Footer>
                </Modal>

                <Modal  
                    show={this.state.GCmodalShow}
                    onHide={this.handleClose}
                    backdrop="static"
                    keyboard={false}
                >
                    <Modal.Header closeButton>
                       <Modal.Title>Search Gift Card</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                    <Row style={{ justifyContent: 'left' }}>
                        <Col style={{ justifyContent: 'left', textAlign: 'left' }}>
                        <Form.Group>
                                <Form.Label>Master Gift Card</Form.Label>
                                {this.state.masterGCList.length>0 &&<select
                                        className="form-control"
                                        style={{ width: 'auto' }}
                                        name="master_gc"
                                        onChange={this.onChangeValues}
                                        value={this.state.master_gc}
                                    >
                                        {this.state.masterGCList.map((masterGC) => (
                                            <option
                                                key={masterGC.title}
                                                value={masterGC.title}
                                            >
                                                {masterGC.title}
                                            </option>
                                        ))}
                                    </select>}

                                
                             </Form.Group>

                            <Form.Group as={Row}>
                            <select
                                className="form-control"
                                style={{ width: 'auto',marginLeft: '0.5rem'}}
                                name="gc_search_by"
                                value={this.state.gc_search_by}
                                onChange={this.onChangeGCBy}
                             >
                                
                                    <option key="search_by_brandName" value="name" >
                                    Name 
                                    </option>
                                    <option key="search_by_sku" value="sku" >
                                    SKU 
                                    </option>
                            </select>
                            
                                    <Form.Control
                                    style={{ width: 'auto',marginLeft: '0.5rem' }}
                                    placeholder="Search Gift Card"
                                    type="text"
                                    name="gc_key"
                                    value={this.state.gc_key}
                                    onChange={this.onChangeGCValues}
                                />   
                                <Button style={{ marginLeft: '0.5rem' }} variant="primary" onClick={this.submitGCSearch} >
                                    Search
                                </Button>
                                <Button  style={{ marginLeft: '0.5rem' }} variant="primary" onClick={this.restGCSearch} >
                                Reset
                                </Button>
                            </Form.Group>
                        </Col>
                    </Row>
                    
                    {this.state.gc_list.length>0 &&<select
                        className="form-control"
                        style={{ width: '100%'}}
                        name="search_key"
                        onChange={this.onSelectGc}
                    >
                        <option key="gc_0" value="" >
                            Select Gift Card
                        </option>
                        {this.state.gc_list.map((gc) => (
                            <option
                                key={gc.sku}
                                value={gc.sku}
                            >
                                {gc.name} ({gc.sku})
                            </option>
                        ))}
                    </select>}
                    </Modal.Body>

                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.handleClose}>
                            Cancel
                        </Button>
                        {this.state.selected_gc &&<Button  variant="primary" onClick={this.UpdateGCConfirmed}>
                        Update Slug
                        </Button>}
                        
                    </Modal.Footer>
                </Modal>
                

            </Container>
        );
    }
}

export default AllGiftCards;
